import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
interface BuyButtonProps {
  label?: string;
  onClick: () => void;
  className?: string;
}
export function BuyButton({
  label = "Quiero dominar mi zurda",
  onClick,
  className = ""
}: BuyButtonProps) {
  return <motion.button type="button" onClick={onClick} whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.03, 1]
  }} transition={{
    duration: 1.8,
    repeat: Infinity,
    ease: "easeInOut"
  }} className={`group flex w-full items-center justify-center gap-2 rounded-full bg-[#d4ff00] px-6 py-4 text-center text-base font-extrabold uppercase tracking-wide text-black shadow-[0_10px_30px_-8px_rgba(212,255,0,0.7)] ring-1 ring-black/10 ${className}`} data-id="element-98" data-mp="2oc5btur28pec">
      <span className="leading-tight" data-id="element-99" data-mp="8jpmsyhnrha0">{label}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-100" data-mp="8laf0hgi2o4p" />
    </motion.button>;
}